import React, {useState} from 'react';
import UploadProducts from "./upload-products";
import UploadedProductsList from "./uploaded-products-list";
import ProductDetailMapping from "./product-detail-mapping";
import ShowTabsList from "../../../common/ui/show-tabs-list";
import {
    DEFAULT_PRODUCT_UPLOAD_TAB,
    PRODUCT_UPLOAD_TABS_LIST
} from "../../constants/pod.constant";
import UploadedProductTypes from "./uploaded-product-types";
import {addProducts, getAllPODProducts, updateProducts} from "../../services/product-data-service";
import {prepareProductsForAddOrUpdate} from "../../utils/product-data-util";
import {
    addParentProducts,
    getAllPODParentProducts,
    updateParentProducts
} from "../../services/parent-product-data-service";
import {prepareParentProductsForAddOrUpdate} from "../../utils/parent-product-data-util";

const tabsList = PRODUCT_UPLOAD_TABS_LIST;

const ProductsUploadDashboard = ({podDetail, setPodDetail}) => {
    const [productStatistics, setProductStatistics] = useState(null);
    const [saveProductsInProgress, setSaveProductsInProgress] = useState(false);
    const [uploadedProducts, setUploadedProducts] = useState(null);
    const [latestProductsList, setLatestProductsList] = useState(null);
    const [latestParentProductsList, setLatestParentProductsList] = useState(null);
    const [uploadedProductFields, setUploadedProductFields] = useState(null);
    const [selectedTab, setSelectedTab] = useState(DEFAULT_PRODUCT_UPLOAD_TAB);
    const [productTypes, setProductTypes] = useState(null);

    const saveProducts = async () => {
        setSaveProductsInProgress(true);

        const existingProducts = await getAllPODProducts(podDetail.id);
        const existingParentProducts = await getAllPODParentProducts(podDetail.id);

        const processedProducts = prepareProductsForAddOrUpdate(latestProductsList, existingProducts);
        const processedParentProducts = prepareParentProductsForAddOrUpdate(latestParentProductsList, existingParentProducts);

        setProductStatistics({
            products: {
                add: processedProducts.add.length,
                update: processedProducts.update.length,
            },
            parentProducts: {
                add: processedParentProducts.add.length,
                update: processedParentProducts.update.length,
            }
        });

        await addProducts(processedProducts.add);
        await updateProducts(processedProducts.update);

        await addParentProducts(processedParentProducts.add);
        await updateParentProducts(processedParentProducts.update);

        setSaveProductsInProgress(false);
    }

    return (
        <>

            <div className="justify-start">
                <div className="flex py-4 px-10 pt-6">
                    <UploadProducts
                        productStatistics={productStatistics}
                        saveProductsInProgress={saveProductsInProgress}
                        saveProducts={saveProducts}
                        podDetail={podDetail}
                        setPodDetail={setPodDetail}
                        setUploadedProducts={setUploadedProducts}
                        setUploadedProductFields={setUploadedProductFields}/>
                </div>

                <div>
                    <ShowTabsList
                        setSelectedTab={setSelectedTab}
                        selectedTab={selectedTab}
                        tabsList={tabsList}/>
                </div>

                <div className="mt-4">

                    {selectedTab?.key === 'fields' &&
                        <div>
                            {uploadedProducts?.length > 0 &&
                                <div className="justify-center">
                                    <ProductDetailMapping
                                        podDetail={podDetail}
                                        setPodDetail={setPodDetail}
                                        uploadedProductFields={uploadedProductFields}
                                        setUploadedProductFields={setUploadedProductFields}/>
                                </div>
                            }
                        </div>
                    }

                    {selectedTab?.key === 'products' &&
                        <div className="justify-center">
                            <UploadedProductsList
                                latestProductsList={latestProductsList}
                                uploadedProductFields={uploadedProductFields}/>
                        </div>
                    }

                    {selectedTab?.key === 'product-summary' &&
                        <div className="justify-center">
                            <UploadedProductTypes
                                podDetail={podDetail}
                                setPodDetail={setPodDetail}
                                setLatestProductsList={setLatestProductsList}
                                setLatestParentProductsList={setLatestParentProductsList}
                                setUploadedProducts={setUploadedProducts}
                                uploadedProductFields={uploadedProductFields}
                                uploadedProducts={uploadedProducts}
                                setProductTypes={setProductTypes}
                                productTypes={productTypes}/>
                        </div>
                    }

                </div>


            </div>

        </>
    )
}

export default ProductsUploadDashboard
